class CleanupFormatting {
  constructor() {
    this.init();
  }

  init() {
    const elements = document.querySelectorAll(
      '[title*="<sup aria-hidden=\'true\'>®</sup>"], [aria-label*="<sup aria-hidden=\'true\'>®</sup>"], [aria-labelledby*="<sup aria-hidden=\'true\'>®</sup>"], [alt*="<sup aria-hidden=\'true\'>®</sup>"]'
    );

    elements.forEach((el) => {
      ['title', 'aria-label', 'aria-labelledby', 'alt'].forEach((attr) => {
        const value = el.getAttribute(attr);
        if (value?.includes("<sup aria-hidden='true'>®</sup>")) {
          el.setAttribute(attr, value.replace(/<sup aria-hidden='true'>®<\/sup>/g, '®'));
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CleanupFormatting();
});
